import React from "react";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
const SubStockName = (props) => {
    const device = DeviceContext();
    return (React.createElement("div", { className: device && device.isDesktop
            ? "DMSanN_14_400 txt_secondary-gray "
            : "DMSansNormal_12_400  txt_secondary-gray " }, props.stockName));
};
export default SubStockName;
